export const RESET_STRINGS = {
  en: {
    TITLE: 'Reset password',
    EMAIL: 'Email',
    NEED_HELP: 'Need help?',
    SEND_LINK: 'Send password reset link',
    LINK_SENT: 'Reset link sent!',
    LINK_EXPIRED: 'The reset link has expired.',
    NEW_LINK: 'Send a new reset link',
    PASSWORD: 'New password',
    PASSWORD_CONFIRMATION: 'Confirm new password',
    CHANGE_PASSWORD: 'Change password',
    PASSWORDS_MUST_MATCH: 'Passwords must match.',
    PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long.',
    PASSWORD_CHANGED: 'Password changed successfully!',
  },
  sv: {
    TITLE: 'Återställ lösenord',
    EMAIL: 'Email',
    NEED_HELP: 'Behöver du hjälp?',
    SEND_LINK: 'Skicka återställningslänk',
    LINK_SENT: 'Återställningslänk skickad!',
    LINK_EXPIRED: 'Återställningslänken är inte längre aktiv.',
    NEW_LINK: 'Skicka en ny återställningslänk',
    PASSWORD: 'Nytt lösenord',
    PASSWORD_CONFIRMATION: 'Bekräfta nytt lösenord',
    CHANGE_PASSWORD: 'Ändra lösenord',
    PASSWORDS_MUST_MATCH: 'Lösenorden måste matcha.',
    PASSWORD_MIN_LENGTH: 'Lösenordet måste innehålla minst 8 tecken.',
    PASSWORD_CHANGED: 'Lösenordet har ändrats!',
  },
  nb: {
    TITLE: 'Tilbakestill passord',
    EMAIL: 'E-postadresse',
    NEED_HELP: 'Trenger du hjelp?',
    SEND_LINK: 'Send tilbakestillingslenk',
    LINK_SENT: 'Tilbakestillingslenken er sendt!',
    LINK_EXPIRED: 'Tilbakestillingslenken er ikke lenger aktiv.',
    NEW_LINK: 'Send a new reset link',
    PASSWORD: 'Nytt passord',
    PASSWORD_CONFIRMATION: 'Bekrefte nytt passord',
    CHANGE_PASSWORD: 'Bytt passord',
    PASSWORDS_MUST_MATCH: 'Passordene må være like.',
    PASSWORD_MIN_LENGTH: 'Passordet må inneholde minst 8 tegn.',
    PASSWORD_CHANGED: 'Passordet er endret!',
  },
  da: {
    TITLE: 'Reset password',
    EMAIL: 'Email',
    NEED_HELP: 'Need help?',
    SEND_LINK: 'Send password reset link',
    LINK_SENT: 'Reset link sent!',
    LINK_EXPIRED: 'The reset link has expired.',
    NEW_LINK: 'Send a new reset link',
    PASSWORD: 'New password',
    PASSWORD_CONFIRMATION: 'Confirm new password',
    CHANGE_PASSWORD: 'Change password',
    PASSWORDS_MUST_MATCH: 'Passwords must match.',
    PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long.',
    PASSWORD_CHANGED: 'Password changed successfully!',
  },
} as const
